import { useEffect } from "react";

export const useAfterPayInjectionScript = () => {
    useEffect(() => {
        const AfterPayScriptElement = document.createElement('script');
        AfterPayScriptElement.src = "/apps/jcom/s4/src/component/afterpay-message/afterpay-message.js";
        AfterPayScriptElement.setAttribute("data-ot-ignore", "data-ot-ignore");
        document.head.appendChild(AfterPayScriptElement);
    }, []);
}